module.exports = __webpack_public_path__ + "img/16.8107cf4d.svg";